import { Col, Row } from "reactstrap";
import {
    OPTIONS_ATTRIBUTE,
    OPTIONS_CONDITION,
    OPTIONS_OPERATOR
} from "../misc/constants";

import CommonModal from "@components/ui-components/modal";
import FieldArrays from "@components/fields/field-arrays";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import size from "lodash/size";
import { useFieldArray } from "react-hook-form";
import useUpsert from "./use-upsert";

const UpsertSegment = props => {
    
    const { modalConfig, handleModal } = props;
    const isEdit = !!size(modalConfig.row);

    const { onSubmit, methods, updateLoading, isDirty, loading } = useUpsert(props);
    const {
        control,
        formState: { errors }
    } = methods;

    const { fields, append, remove } = useFieldArray({
        name: "conditions",
        control
    });

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the segment which you wish to create"
            },
            rightChild: (
                <Row>
                    <InputField
                        id="name"
                        name="name"
                        label="Name"
                        required
                        control={control}
                        errors={errors}/>
                    <InputField
                        label="Description"
                        id="description"
                        name="description"
                        control={control}
                        errors={errors}/>
                    <Select
                        label="Operator"
                        required
                        id="operator"
                        name="operator"
                        control={control}
                        errors={errors}
                        options={OPTIONS_OPERATOR}/>
                </Row>
            )
        },
        {
            leftChild: {
                title: "Add Conditions"
            },
            rightChild: (
                <FieldArrays
                    render={index => (
                        <>
                            <Col md={12}>
                                <Select
                                    label="Attribute"
                                    required
                                    id={`attribute-${index}`}
                                    name={`conditions.${index}.attribute`}
                                    control={control}
                                    errors={errors}
                                    options={OPTIONS_ATTRIBUTE}/>
                            </Col>
                            <Col md={6}>
                                <Select
                                    label="Condition"
                                    required
                                    id={`attributeCondition-${index}`}
                                    name={`conditions.${index}.attributeCondition`}
                                    control={control}
                                    errors={errors}
                                    options={OPTIONS_CONDITION}/>
                            </Col>
                            <Col md={6}>
                                <InputField
                                    id={`attributeValue-${index}`}
                                    name={`conditions.${index}.attributeValue`}
                                    type="number"
                                    label="Value"
                                    control={control}
                                    errors={errors}
                                    prefix={{ txt: "$" }}/>
                            </Col>
                        </>
                    )}
                    fields={fields}
                    subject="segments"
                    handleAppend={() => append({
                        attribute         : "",
                        attributeCondition: "",
                        attributeValue    : 0
                    })
                    }
                    handleRemove={index => {
                        remove(index);
                    }}
                    disabledAppend={false}
                    disabledRemove={false}/>
            )
        }
    ];

    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Segment`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="extraLarge"
            isDirty={isDirty}
            loading={loading}
            handleModal={handleModal}
            isOpen={modalConfig.isOpen}/>
    );
};

export default UpsertSegment;
